import { Translation } from "@/data/lang";

export const getMarginTransactionsPeriodOptions = ({
  t,
}: {
  t: Translation;
}) => [
  { label: `10${t.analysis.chip.institutionalInvestors.days}`, value: "10" },
  { label: `30${t.analysis.chip.institutionalInvestors.days}`, value: "30" },
  { label: `60${t.analysis.chip.institutionalInvestors.days}`, value: "60" },
];
